import styled from 'styled-components';
import { White } from '../../../colors';
import { SCREEN_SIZE } from '../../grid/constants/sizes';
import { GridContainer, Row } from '../../grid';
export const BackgroundHeader = styled('div') `
    width: 100%;
    height: 90px;
    background-color: ${White.normal};
    position: fixed;
    box-shadow: 0 2px 16px 0 rgba(157,154,154,0.2);

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
export const PageContainer = styled(GridContainer) `
    
`;
export const RowContent = styled(Row) `
    align-content: center;
    min-height: calc(100vh - 190px);
    margin-top: 100px;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        margin-top: 70px;
        height: auto;
    }
`;
export const RowFooter = styled(Row) `
    width: 100%;
    height: 100px;
`;
export const RowHeader = styled(Row) `
    background-color: ${White.normal};
    height: 90px;
    z-index: 1000;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
//# sourceMappingURL=CollectionsLayout.styled.js.map